import React, {FC} from 'react';
import circularProgress from '../../../public/assets/lottie/circularProgress.json';
import Lottie from 'lottie-react-web';

interface ProcessingPaymentScreenProps {}
const ProcessingPaymentScreen:FC<ProcessingPaymentScreenProps> = (props) => {

	return (
		<div className="h-full flex flex-col items-center justify-center gap-3">
			<div className="w-14 h-14">
				<Lottie
					options={{animationData: circularProgress, loop: true}}
				/>
			</div>
			<p className={"text-white  text-opacity-70"}>Processing Payment</p>
		</div>
	)
}

export default ProcessingPaymentScreen;
